import { MONEY_TRANSACTION_PG_REPORT } from 'actions/dataReport';

const initialState = {
  isLoading: false,
  moneyTransactionPgReports: [],
  page: 1,
  limit: 10,
  totalPages: 1,
  total: 1,
};

const moneyTransactionPgReportReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case MONEY_TRANSACTION_PG_REPORT.REQUEST: {
      return { ...state, isLoading: true };
    }

    case MONEY_TRANSACTION_PG_REPORT.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        moneyTransactionPgReports: payload.results,
        page: payload.page,
        limit: payload.limit,
        totalPages: payload.totalPages,
        total: payload.totalResults,
      };
    }

    case MONEY_TRANSACTION_PG_REPORT.FAIL: {
      return { ...state, isLoading: false };
    }

    default:
      return { ...state };
  }
};
export default moneyTransactionPgReportReducer;
